import { render, staticRenderFns } from "./Styleguide.vue?vue&type=template&id=e39e301e&scoped=true&"
import script from "./Styleguide.vue?vue&type=script&lang=ts&"
export * from "./Styleguide.vue?vue&type=script&lang=ts&"
import style0 from "./Styleguide.vue?vue&type=style&index=0&id=e39e301e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39e301e",
  null
  
)

/* custom blocks */
import block0 from "./Styleguide.vue?vue&type=custom&index=0&blockType=Styleguide&%3Astyleguide=DSSOutputObject"
if (typeof block0 === 'function') block0(component)

export default component.exports